import type { IdentityAdapter } from '../types';
export const webIdentity: IdentityAdapter = { user() { return null; } };
